import cricketIcon from "@/assets/icons/sports/cricket.png";
import footballIcon from "@/assets/icons/sports/football.png";
import { EventCategory } from "@yn/utils";
import type { StaticImageData } from "next/image";

const sportIconMap: Partial<Record<EventCategory, StaticImageData>> = {
    [EventCategory.Cricket]: cricketIcon,
    [EventCategory.Football]: footballIcon,
};

export function getSportIcon( eventCategory: EventCategory ) {
    return sportIconMap[eventCategory] ?? null;
}
